import {faro} from '@grafana/faro-react';

import type {AnyRouter} from '@tanstack/react-router';

export function trackFaroRouter(router: AnyRouter): () => void {
  const updateView = () => {
    const [matchedRoutes] = router.getMatchedRoutes(
      router.state.location.pathname,
    );
    const routeId =
      router.state.matches.at(-1)?.routeId ?? matchedRoutes.at(-1)?.id;

    if (routeId) faro.api?.setView({name: routeId});
  };

  updateView();

  return router.subscribe('onResolved', updateView);
}
